import React from "react";

const Edit = ({ children, widthXL }) => {
  return (
    <div className={`w-9/10 ${widthXL} bg-white p-10 shadow-2xl`}>
      {children}
    </div>
  );
};

export default Edit;
